import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../Components/NavigationLayout";
import Edit from "./Edit";

const Students = () => {
  return (
    <NavigationLayout>
      <Router history={history}>
        <Switch>
          <Route exact path="/admin/students" component={List} />
          <Route path="/admin/students/new" component={Add} />
          <Route path="/admin/students/:id" component={Edit} />
        </Switch>
      </Router>
    </NavigationLayout>
  );
};
export default Students;
